import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, NgIf } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-overview-details',
  standalone: true,
  imports: [
    NgIf,
    MatDividerModule,
    MatListModule,
    CurrencyPipe,
    DatePipe,
    TranslateModule
  ],
  templateUrl: './overview-details.component.html',
  styleUrls: ['./overview-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewDetailsComponent {

  @Input() company!: any;

}
